import React, { useRef } from "react";
import PropTypes from "prop-types";
import SelectDDI from "./index";

function FormikSelectDDI({
  field: { onChange, value, onBlur, name },
  form: { isSubmitting, setFieldTouched },
  InputProps,
  ...props
}) {
  const chaveDictionaryCountry = useRef(null);

  function handle(pValue, chaveDic) {
    chaveDictionaryCountry.current = chaveDic;

    onChange({ target: { name, value: pValue } }, name);
    onBlur({ target: { name, value: pValue } }, name);
    setTimeout(() => setFieldTouched(name, true));
  }
  return (
    <SelectDDI
      value={value}
      disabled={isSubmitting}
      onChange={handle}
      {...InputProps}
      {...props}
      ref={chaveDictionaryCountry}
    />
  );
}

FormikSelectDDI.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  InputProps: PropTypes.object,
};

export default FormikSelectDDI;
